(function(ws) {
    'use strict';

    ws.views.baseWidget = ws.views.googleAnalytics.extend({});
})(westcon);
